import { style } from '@vanilla-extract/css';

export const bar = style({
  display: 'block',
  width: '100%',
});
